import React, { useEffect, useState } from "react";
import {
  Modal,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle
} from "@hello-pangea/dnd";

import layer from "../../assets/images/icons/whiteboard-menu-left-3.svg";
import btnHide from "../../assets/images/icons/whiteboard-menu-left-4.svg";
import btnShow from "../../assets/images/icons/whiteboard-menu-left-7.svg";
import {
  BoardElementGroupDeleteAction,
} from "../../store/screen/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

const ElementHide = ({
  data,
  ComponentDisplay,
  StrokeDisplay,
  setVisibilityByType,
  setDataList,
  setSchedule,
}: any) => {
  const dispatch = useAppDispatch();

  const removeAllComponent = () => {
    const componentIds = data
      .filter((el: any) => el.type !== 'WIDGET_STROKES')
      .map((el: any) => String(el.id));

    const notSelectedObjs = (() => {
      const picked = new Set(componentIds);
      return data.filter((el: any) => !picked.has(String(el.id)));
    })();
    notSelectedObjs.map((item: any, index: number) => {
      return item.idx = index;
    });
    setDataList(notSelectedObjs);
    setSchedule(notSelectedObjs);

    console.log("componentIds", componentIds);
    console.log("notSelectedObjs", notSelectedObjs);


    dispatch(BoardElementGroupDeleteAction({ ids: componentIds }));
  };

  const removeAllStroke = () => {
    const strokeIds = data
      .filter((el: any) => el.type === 'WIDGET_STROKES')
      .map((el: any) => String(el.id));

    const notSelectedObjs = (() => {
      const picked = new Set(strokeIds);
      return data.filter((el: any) => !picked.has(String(el.id)));
    })();
    notSelectedObjs.map((item: any, index: number) => {
      return item.idx = index;
    });
    setDataList(notSelectedObjs);
    setSchedule(notSelectedObjs);

    console.log("strokeIds", strokeIds);
    console.log("notSelectedObjs", notSelectedObjs);


    dispatch(BoardElementGroupDeleteAction({ ids: strokeIds }));
  };

  return (
    <React.Fragment>
      <UncontrolledDropdown className="top-tool-group layerTool">
        <DropdownToggle tag="button" className="feature-anchor top-tool-btn" id="top-tool-hide-dropdown" data-tooltip-content="物件/劃記隱藏">
          <img src={btnShow} alt="" />
        </DropdownToggle>
        <DropdownMenu>
          <div className="top-tool-group">
            <div className="top-tool-items">
              <DropdownItem
                onClick={() => {
                  setVisibilityByType('WIDGET_STROKES', { include: false, value: ComponentDisplay? false : 'toggle' });
                }}
              >
                {ComponentDisplay? (
                  <>
                    <img src={btnHide} style={{ width: "30px" }} alt="" />
                    <div>隱藏全部工具</div>
                  </>
                ) : (
                  <>
                    <img src={btnShow} style={{ width: "30px" }} alt="" />
                    <div>顯示全部工具</div>
                  </>
                )}
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  setVisibilityByType('WIDGET_STROKES', { include: true, value: StrokeDisplay? false : 'toggle' });
                }}
              >
                {StrokeDisplay? (
                  <>
                    <img src={btnHide} style={{ width: "30px" }} alt="" />
                    <div>隱藏全部劃記</div>
                  </>
                ) : (
                  <>
                    <img src={btnShow} style={{ width: "30px" }} alt="" />
                    <div>顯示全部劃記</div>
                  </>
                )}
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  removeAllStroke();
                }}
              >
                <img src={btnShow} style={{ width: "30px" }} alt="" />
                <div>清除全部劃記</div>
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  removeAllComponent();
                }}
              >
                <img src={btnShow} style={{ width: "30px" }} alt="" />
                <div>清除全部工具</div>
              </DropdownItem>
            </div>
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
    </React.Fragment>
  );
};

export default ElementHide;